import { Component } from '@angular/core';

@Component({
  selector: 'app-card-stack',
  imports: [],
  templateUrl: './card-stack.html',
  styleUrl: './card-stack.scss',
})
export class CardStack {
  images = [
    '/images/home/stack/card1.webp',
    '/images/home/stack/card2.webp',
    '/images/home/stack/card3.webp',
    '/images/home/stack/card4.webp',
    '/images/home/stack/card5.webp',
  ];
}
